import axios from "axios";
import { API } from "@/apiConfig";

const H = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

// Gateway-style statuses (502/503/504) can have their body replaced by a CDN/ingress before it
// reaches the browser — never show that raw text to the cashier, fall back to our own wording.
export function friendlyPinpadError(e) {
  const status = e?.response?.status;
  const detail = e?.response?.data?.detail;
  if (status === 502 || status === 503 || status === 504 || !detail) return "Pinpad did not answer — type the number";
  return detail;
}

// Ask the active card terminal for this register (ModeskP1/Dejavoo) to prompt the customer for
// their phone number on the pinpad, and return the 10 digits they typed. Throws an axios-shaped
// error (with .response.data.detail) on any failure — callers fall back to typing it.
export async function requestPhoneFromPinpad(stationId) {
  const sid = stationId || "default";
  const t = await axios.get(`${API}/settings/terminal`, { ...H(), params: { station_id: sid } });
  const type = t.data?.terminal_type;
  if (type !== "dejavoo") {
    throw { response: { data: { detail: "No card terminal configured for this register — type the number" } } };
  }
  const r = await axios.post(`${API}/customers/dejavoo/phone`, { station_id: sid }, H());
  return r.data.phone;
}
